<template>
  <BigModal @close="$emit('close')" :title="lang['editComp']" customClass="custom-class">
    <div class="div-container">
      <div>
        <label for="new-company-name">{{ lang['CompanyName'] }}</label>
        <b-form-input v-model="newCompanyName" autofocus :state="stateCompanyName" name="name" />
      </div>
      <div>
        <label for="new-company-desc">{{ lang['description'] }}</label>
        <b-form-input v-model="newCompanyDesc" />
      </div>
      <div>
        <label class="label-add" for="new-company-name">{{ lang['addlogo'] }}</label>
      </div>
      <cropImage field="img" @close="toggleShow" @clearimage="clearimage" @crop-success="cropSuccess"
        @crop-upload-success="cropUploadSuccess" @crop-upload-fail="cropUploadFail" :noCircle="true" :noSquare="true"
        v-if="show" :width="256" :height="256" img-format="png">
      </cropImage>
      <div class="img-container">
        <span v-if="defaultImg == false" class="icon-close close-img" @click="clearimage"></span>
        <img v-if="defaultImg == false" class="imgChange" :src="this.logo">
        <img v-else class="imgChange"
          src="data:image/png;base64,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">
      </div>
      <b-button v-if="defaultImg" variant="info" class="defaultImg-button" @click="toggleShow">{{ lang['zagruzit_foto']
      }}</b-button>
    </div>
    <template v-slot:buttons>
      <div class="buttonitem">
        <button class="btn btn-secondary" @click="$emit('close')">
          {{ lang['Сancel'] }}
        </button>
      </div>
      <div class="buttonitem">
        <button class="btn btn-success" @click="save">
          {{ lang['Proceed'] }}
        </button>
      </div>
    </template>
  </BigModal>
</template>

<script>
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import cropImage from '@/components/cropimage/crop.vue';
import BigModal from '../modals/bigModal.vue';  // Компонент великого модального вікна
export default {
  props: ['targetCompany'],
  components: {
    cropImage,
    BigModal,
  },
  data() {
    return {
      logoUrl: "https://files.skyservice.pro/uploads/images/",
      logo: '',
      show: false,
      defaultImg: false,
      imgUrl: '',
      newCompanyName: '',
      newCompanyDesc: ''
    }
  },
  mounted() {
    this.newCompanyName = this.targetCompany.company_name;
    this.newCompanyDesc = this.targetCompany.company_description;
    keyevent.$off('enter');
    keyevent.$on('enter', () =>
      this.save()
    );
  },
  created() {
    if (this.targetCompany.logo !== "") {
      this.logo = this.logoUrl + this.targetCompany.company_id + '/' + this.targetCompany.logo;
    } else {
      this.defaultImg = true;
    }
  },
  methods: {
    clearimage() {
      this.defaultImg = true;
      this.logo = '';
      window.say.message(this.lang["logoIsDel"]);
    },
    cropSuccess(imgDataUrl, field) {
      this.defaultImg = false
      window.say.message(this.lang["logoIsAdd"])
      this.logo = imgDataUrl;
      console.log(imgDataUrl);
      console.log(field);
    },
    cropUploadSuccess(jsonData, field) {
      console.log(jsonData);
      console.log('field: ' + field);
    },
    cropUploadFail(status, field) {
      console.log(status);
      console.log('field: ' + field);
    },
    toggleShow() {
      this.show = !this.show;
    },
    uploadImg(e) {
      console.log(e.target.files);
      let file = e.target.files[0];
      let url = '';
      var reader = new FileReader();
      reader.readAsDataURL(file);
      let that = this;
      reader.onload = function (e) {
        console.log(e)
        url = this.result.substring(this.result.indexOf(',') + 1);
        that.imgUrl = 'data:image/png;base64,' + url
      }
    },
    // по апи сверяем, не т ли у нас такой почты в базе, если все ок, закрываем модалку и перекидываем введенную почту в родителя, а от туда в следующую модалку
    save() {
      if (this.checkAllInput) {
        let data = {
          logo: this.logo,
          name: this.newCompanyName,
          desc: this.newCompanyDesc
        }
        this.$emit("save", data);
        this.$emit("close");
      } else {
        window.say.messageError(this.lang['FillInAllTheFields']);
      }
    },
  },
  computed: {
    stateCompanyName() {
      const reg = /[^\s]/;
      if (reg.test(this.newCompanyName) && this.newCompanyName.length > 2 && this.newCompanyName.length < 75) {
        return true;
      } else {
        return false;
      }
    },
    checkAllInput() {
      let inputs;
      if (this.stateCompanyName) {
        inputs = true;
      } else {
        inputs = false
      }
      return inputs;
    },
    // Мова додатку
    lang() {
      return window.lang;
    },
  }
}
</script>

<style scoped>
.defaultImg-button {
  width: 259px;
}

.imgChange {
width: 200px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.btn-secondary,
.btn-success {
  width: 100%
}

.label-add {
  margin-bottom: 0px !important;
}

.div-container {
  padding: 15px;
}

.img-container {
  width: 259px;
  position: relative;
}

.close-img {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 40px;
  width: 40px;
  right: -10px;
  top: -10px;
  font-size: 20px;
  border-radius: 20px;
  background-color: #dc3545;
  color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.7);
}

.close-img:hover {
  background-color: #c82333;
}

.form-control.is-valid, .form-control.is-valid:focus {
  border-color: #00c279;
}

.form-control.is-valid {
  border-color: #00c279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid, .form-control.is-invalid:focus {
  border-color: #ff3548;
}

.form-control.is-invalid {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}

.btn-success {
  background-color: #00c279;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success:hover {
  background-color: #00B26F;
}

.btn-secondary {
  background-color: gray;
  color: white;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-secondary:not(:disabled):not(.disabled):active {
  background-color: white;
  color: gray;
}

/* .btn-secondary:hover {
  text-decoration: underline;
  color: gray;
  background-color: white;
} */
</style>

<style>
@media (max-width: 767px) {
  .custom-class .none_overlay .content {
    width: 100%;
    /* height: 90%; */
    top: 5%;
    margin: 0 auto;
  }

  /* .custom-class .footer_buttons {
    left: 8px;
    width: calc(100% - 17px);
  } */
}

@media (min-width: 768px) {
  .custom-class .none_overlay .content {
    width: 60%;
    height: 85%;
    top: 5%;
    margin: 0 auto;
  }

    /* .custom-class .none_overlay {
      display: flex;
      align-self: center;
      justify-content: center;
  } */

  /* .custom-class .footer_buttons {
    left: 167px;
    top: 745px;
    width: calc(100% - 335px);
  } */

  /* .custom-class.dialogbox .paper {
    height: calc(100vh - 277px);
  } */
}

  /* .custom-class .none_overlay .content {
  width: 80%;
  height: 90%;
top: 5%;
margin: 0 auto;
}

.custom-class .footer_buttons {
  left: 53px;
  width: calc(100% - 106px);
} */</style>